<div class="car-card-seller" >
  <div class="car-image">
    <div class = "image-container">
      @if (carImagesFolder?.length! < 1 && offer?.imagesFilenames?.length! > 0) {
        <p class="spinner">
          <mat-spinner style="margin:0 auto;"  [diameter]="35"></mat-spinner>
        </p>
      }
      <img mat-card-image [src]="(currentImage != undefined) ? currentImage : 'assets/images/car_image_holder.webp'" alt="Car Image">
      <div class = "img-arrow-container">
        <button [disabled]="!(carImagesFolder != undefined && carImagesFolder!.length > 1)" mat-button (click)="prevImage();$event.stopPropagation()" class="pic-arrow-left"><mat-icon>arrow_back_ios</mat-icon></button>
        <button [disabled]="!(carImagesFolder != undefined && carImagesFolder!.length > 1)" mat-button (click)="nextImage();$event.stopPropagation()" class="pic-arrow-right"><mat-icon>arrow_forward_ios</mat-icon></button>
      </div>

      @if ((carImagesFolder != undefined && carImagesFolder!.length > 0)) {
        <div class = "img-counter">
          {{ currentImageIndex + 1 }}/{{ carImagesFolder!.length }}
        </div>
      }
    </div>
    <div class = "image-thumbs">

      @for (file of carImagesFolder  ; track file; let i = $index) {
        <div class="image-thumb"
          [style.border-color]=" (i===currentImageIndex) ? 'yellow': 'white'">
          <!-- <p class="spinner" *ngIf="carImagesFolder?.length! < 1 && offer.imagesFilenames?.length! > 0">
          <mat-spinner style="margin:0 auto;"  [diameter]="35"></mat-spinner>
        </p>  -->
        <!-- <img mat-card-image [src]= "(currentImage != undefined) ? currentImage : 'assets/images/car_image_holder.png'" alt="Car Image">
        -->
        <!-- <img src= "assets/images/car_image_holder.png" alt="Car Image"> -->
        <img mat-card-image
          [src]="(carImagesFolder.length! > 0) ? getCarImage(i) : 'assets/images/car_image_holder.png'" alt="Car Image"
          (click)="selectImage(i)"
          >
        </div>
      }
    </div>

    <div class="car-pic-upload">
      <label for="files" class="btn"> Ajouter photo </label>
      <input id="files" type="file" accept="image/*" multiple (change)="uploadImage(offer.carId,$event); $event.stopPropagation()" />
    </div>

    <!-- <div class="seller-actions">
    <button class="cta-button"  mat-button (click)="openPriceDialog(offer.carId) ;$event.stopPropagation()">Changer le Prix<mat-icon>attach_money</mat-icon></button>
  </div> -->

  <div class="car-infos">

    <div class="car-infos-block">

      <h4>{{offer?.make +" "+ offer?.model +" "+ offer.version }}, {{offer.year }}</h4>
      @if (offer.businessLine===CarBusinessLine.BUY) {
        <div class="car-infos-line">
          <!--
          <div>
            <b>En Vente &nbsp; </b>
            <mat-slide-toggle
              class="example-margin"
              [(ngModel)]="offer.offerClosed"
              [disabled]="false"
              (change)="updateBusinessLineStatus(offer.carId, offer.offerClosed, CarBusinessLine.BUY)">
            </mat-slide-toggle>
          </div>
          -->
          <div>
            <b>Prix </b>
            <button [disabled]="! offer.offerClosed" matButton class="simple-button-buy"  mat-button (click)="openPriceDialog(offer.carId, offer.buyPrice.amount, CarBusinessLine.BUY );$event.stopPropagation()">
              <b>{{ moneyFormat(""+$safeNavigationMigration(offer.buyPrice?.amount)) }} {{ offer.buyPrice?.currency}} </b><mat-icon>edit</mat-icon>
            </button>
          </div>
          <button matButton class="simple-button-buy"  mat-button (click)="openPriceHistoryDialog(offer.buyPriceHistory, CarBusinessLine.BUY);$event.stopPropagation()">
            Historique <mat-icon>timeline</mat-icon>
          </button>
        </div>
      }

      @if (offer.businessLine===CarBusinessLine.RENT) {
        <div class="car-infos-line">
          <!--
          <div>
            <b> En Location &nbsp; </b>
            <mat-slide-toggle
              class="example-margin"
              [(ngModel)]="offer.offerPosted"
              [disabled]="false"
              (change)="updateBusinessLineStatus(offer.carId, offer.offerPosted, CarBusinessLine.RENT)">
            </mat-slide-toggle>
          </div> -->
          <div>
            <b>Tarif jour </b>
            <button [disabled]="!offer.offerPosted" matButton class="simple-button-rent"  mat-button (click)="openProviderOfferDialog();$event.stopPropagation()">
              <b> {{ moneyFormat(""+$safeNavigationMigration(offer.rentDayRate?.amount)) }} {{offer.rentDayRate?.currency}} /J</b><mat-icon>edit</mat-icon>
            </button>
          </div>
          <button matButton class="simple-button-rent"  mat-button (click)="openPriceHistoryDialog(offer.rentDayRateHistory, CarBusinessLine.RENT);$event.stopPropagation()">
            Historique <mat-icon>timeline</mat-icon>
          </button>
        </div>
      }

      @if (offer.businessLine===CarBusinessLine.RENT) {
        <div class="car-infos-line">
          <app-booking-edit
            [carId]="offer.carId"
            [currentBookings]="offer.myBookings">
          </app-booking-edit>
        </div>
      }
      <h6><label>Moteur: </label>{{offer.engine}}, {{offer.fuel}}, {{offer.gearBox }}, {{offer.mileage}} KM - {{offer.features}}</h6>

      <h6><label>Propriétaire:</label> {{offer.ownerName}} , <label>Provider:</label> {{offer.providerName }} </h6>
      <h6><label>Localisation:</label> {{offer.city}}, {{offer.country}}</h6>
      <h6><label>Postée / Dernière mis à jour:</label> {{dateFormat(offer.created)}} / {{dateFormat(offer.lastUpdated)}} </h6>
      <h6>
        <label>Statut: </label>
        Posté: <span ><mat-icon [style.color]="offer.offerPosted ? 'green' : 'red'"> {{ offer.offerPosted ? 'check_circle' : 'cancel' }}</mat-icon></span> |
        Ouvert: <span ><mat-icon [style.color]="offer.offerClosed ? 'red' : 'green'"> {{ offer.offerClosed ? 'cancel' : 'check_circle' }}</mat-icon></span>
      </h6>
    </div>

    <mat-divider></mat-divider>

    <div class="car-infos-line">

      <div>
        <b> Provider Active &nbsp; </b>
        <mat-slide-toggle
          class="example-margin"
          [(ngModel)]="providerActive"

          [disabled]="false"
          (change)="updateProviderActiveStatus(offer.carId, providerActive)">

        </mat-slide-toggle>
      </div>

      <div>
        <b>Provider sélectionné: </b>
        <button [disabled]="!providerActive" matButton class="simple-button"  mat-button (click)="openProviderDialog(offer.carId);$event.stopPropagation()">
          <b> {{ offer.providerId === '' ? 'no provider': offer.providerId }}</b><mat-icon>edit</mat-icon>
        </button>
      </div>
    </div>


    <mat-divider></mat-divider>

    <div class="seller-actions">
      <!--
      <div>
        <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="View car details" (click)="goToCarDetailsPage(offer.carId);$event.stopPropagation()">Détails<mat-icon>open_in_new</mat-icon></button>
      </div>

      <button *ngIf="isSeller" mat-button matTooltipPosition="above" matTooltip="Edit car details" (click)="goToCarEditPage(offer.carId)" ><mat-icon>edit</mat-icon></button>
      -->

      @if (!(offer.offerPosted)) {
        <button
          class="simple-button-{{offer.businessLine.toLowerCase()}}"  mat-button (click)="deleteOffer(offer.carId, offer.offerId, offer.businessLine);$event.stopPropagation()">
          <mat-icon>delete</mat-icon>
        </button>
      }

      <button class="simple-button-{{offer.businessLine.toLowerCase()}}" mat-button matTooltipPosition="above" matTooltip="Update car details" (click)="openProviderOfferDialog();$event.stopPropagation()" >
        Editer<mat-icon>edit</mat-icon>
      </button>

      <button class="simple-button-{{offer.businessLine.toLowerCase()}}" mat-button matTooltipPosition="above" matTooltip="Share">
        Partager<mat-icon>share</mat-icon>
      </button>

    </div>

    <mat-divider></mat-divider>

    <div class="seller-actions">

      <div>
        <button [disabled]="offer.offerClosed" class="simple-button" mat-button matTooltipPosition="above" matTooltip="Publish" (click)="toggleProviderOfferPosted(offer.carId, offer.offerId, offer.businessLine);$event.stopPropagation()" >
          {{ offer.offerPosted ? 'Dépublier' : 'Publier' }} <mat-icon [style.color]="! offer.offerPosted ? '#008000':'#ff0000'"> {{ offer.offerPosted  ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </div>

      <div>
        <button
          class="simple-button-{{offer.businessLine.toLowerCase()}}"  mat-button (click)="toggleProviderOfferClosed(offer.carId, offer.offerId, offer.businessLine);$event.stopPropagation()">
          {{ offer.offerClosed ? 'Ouvrir' : 'Fermer' }} <mat-icon [style.color]="offer.offerClosed ? '#008000':'#ff0000'"> {{ offer.offerClosed  ? 'public' : 'public_off' }}</mat-icon>
        </button>
      </div>

      <!--
      <div>
        <button class="cta-button-buy" mat-button matTooltipPosition="above" matTooltip="Update offer details" (click)="openProviderOfferDialog();$event.stopPropagation()" >
          Mettre en vente<mat-icon>add</mat-icon>
        </button>
      </div>

      <div>
        <button class="cta-button-rent" mat-button matTooltipPosition="above" matTooltip="Update offer details" (click)="openProviderOfferDialog();$event.stopPropagation()" >
          Mettre en location<mat-icon>add</mat-icon>
        </button>

      </div> -->
    </div>

  </div>

</div>

<div class="car-data">

  <mat-accordion multi>

    @if (offer.proposals != undefined) {
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Propositions recues <span>({{offer.proposals!.length}}) </span></h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="car-data-section">
          <!--
          <span *ngIf="!(offer.appointments.length > 0)">
            Aucune rendez vous en cours
          </span>
          <app-appointments
            *ngIf="(offer.appointments.length > 0)"
            [appointments]="offer.appointments"
            [newAppointmentCarId]="newAppointmentCarId"
            [newAppointmentCount]="newAppointmentCount">
          </app-appointments> -->
          <app-proposals
            [objectSource]="objectSource"
            [offerId]="offer.offerId"
            [enableNew]="false">
          </app-proposals>
        </div>
      </mat-expansion-panel>
    }

    @if (offer.myBookings != undefined) {
      <mat-expansion-panel [expanded]="false" expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4> Réservations en cours <span>({{offer.myBookings.length}}) </span></h4>
            <button
              class="simple-button-rent"  mat-button (click)="openBookingDialog(0);$event.stopPropagation()">
              <mat-icon>add</mat-icon> Nouvelle
            </button>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-bookings
          [objectSource]="objectSource"
          [offerId]="offer.offerId"
          [enableNew]="false">
        </app-bookings>
      </mat-expansion-panel>
    }

    @if (offer.appointments != undefined) {
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Rendez vous <span>({{offer.appointments.length}}) </span></h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="car-data-section">
          <!--
          <span *ngIf="!(offer.appointments.length > 0)">
            Aucune rendez vous en cours
          </span>
          <app-appointments
            *ngIf="(offer.appointments.length > 0)"
            [appointments]="offer.appointments"
            [newAppointmentCarId]="newAppointmentCarId"
            [newAppointmentCount]="newAppointmentCount">
          </app-appointments> -->
          <app-appointments
            [objectSource]="objectSource"
            [offerId]="offer.offerId"
            [enableNew]="false">
          </app-appointments>
        </div>
      </mat-expansion-panel>
    }


    @if (offer.conversations != undefined) {
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Conversations<span>({{offer.conversations.length}}) </span></h4>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="car-data-section">
          <div class="section-title">
          </div>
          <div class="conversations">
            <app-conversations
              [objectSource]="objectSource"
              [offerId]="offer.offerId"
              [enableNew]="false"
              >
            </app-conversations>
          </div>
        </div>
      </mat-expansion-panel>
    }

    @if (offer.jobs != undefined) {
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Activités <span>({{offer.jobs.length}}) </span></h4>
            <button class="simple-button" mat-button (click)="openNewJobDialog(offer.carId);$event.stopPropagation()">
              <mat-icon>add</mat-icon>Nouvelle
            </button>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if ((offer.jobs.length >= 0)) {
          <app-jobs
            [objectSource]="objectSource"
            [carId]="offer.carId"
            [enableNew]="false"
            [potentialProviders]="currentDealer.favoriteProviderIds">
          </app-jobs>
        }
      </mat-expansion-panel>
    }

  </mat-accordion>
</div>

</div>
